
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programmation",
      function () {
        return require("private-next-pages/programmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programmation"])
      });
    }
  